import { StatsSectionProps } from '../components/features/StatsSection/StatsSection.types';
import { AISystemSummaryDto } from '../types/AISystems.types';

export const mapSummaryToStatsSection = (
  summaryData: AISystemSummaryDto
): StatsSectionProps => {
  const complianceData = {
    compliant: summaryData.compliant,
    inProgress:
      summaryData.byComplianceStatus.find(
        (item) => item.status === 'IN_PROGRESS' || item.status === 'YELLOW'
      )?.count || 0,
    nonCompliant: summaryData.nonCompliant,
  };

  const riskData = {
    minimal: summaryData.byRiskLevel.reduce((acc, item) => {
      if (['MINIMAL_RISK', 'EXCLUDED', 'OUT_OF_SCOPE'].includes(item.risk)) {
        return acc + item.count;
      }
      return acc;
    }, 0),
    limited:
      summaryData.byRiskLevel.find((item) => item.risk === 'LIMITED_RISK')
        ?.count || 0,
    high: summaryData.byRiskLevel.reduce((acc, item) => {
      if (['HIGH_RISK', 'HIGH_RISK_EXCEPTION'].includes(item.risk)) {
        return acc + item.count;
      }
      return acc;
    }, 0),
    prohibited:
      summaryData.byRiskLevel.find((item) => item.risk === 'PROHIBITED')
        ?.count || 0,
    other:
      summaryData.byRiskLevel.find((item) => item.risk === 'OTHER')
        ?.count || 0,
  };

  return {
    totalSystems: summaryData.total,
    complianceData,
    riskData,
  };
};
